import { useSelector } from "react-redux";
import {
  PLAN_SLUGS,
  isPaidPlan,
  isGrandfatheredPlus,
} from "../constants/plans";

// Single source of truth for "what plan is this user on, and what does that mean?"
// Replaces the ad-hoc `["pro","free-trial"].includes(user?.plan?.slug)` checks
// scattered across the app.
const usePlan = () => {
  const user = useSelector((state) => state.auth?.user);
  const plan = user?.plan || null;
  const slug = plan?.slug || null;
  const planId = plan?.id != null ? Number(plan.id) : null;

  const isPaid = isPaidPlan(slug);

  return {
    plan,
    slug,
    planId,
    isPaid,
    isFree: !slug || slug === PLAN_SLUGS.FREE,
    isGrandfatheredPlus: isGrandfatheredPlus(planId),
    // All paid tiers (plus / pro / pro-trial / pro-newsletter) get identical
    // app feature access — Newsletter only adds email content, not features.
    hasFullAccess: isPaid,
    // Eligible for the paid Pro Trial: hasn't used it before AND isn't already
    // on a paid plan AND isn't currently on Pro Trial. Use this anywhere a
    // "Start trial" CTA might be shown.
    isTrialEligible:
      !user?.has_used_pro_trial && !isPaid && slug !== PLAN_SLUGS.PRO_TRIAL,
  };
};

export default usePlan;
